import { Label as LabelPrimitive } from "radix-ui";
import { forwardRef, type ComponentPropsWithoutRef, type ComponentRef } from "react";
import { cn } from "@/lib/cn";

export const Label = forwardRef<ComponentRef<typeof LabelPrimitive.Root>, ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & { required?: boolean; optional?: boolean }>(
  function Label({ className, required, optional, children, ...props }, ref) {
    return (
      <LabelPrimitive.Root ref={ref} className={cn("inline-flex items-center gap-1 text-sm font-bold text-fg peer-disabled:opacity-60", className)} {...props}>
        {children}
        {required && (
          <span aria-hidden className="text-danger-ink">
            *
          </span>
        )}
        {optional && <span className="font-medium text-fg-muted">(optional)</span>}
      </LabelPrimitive.Root>
    );
  },
);
